<template>
  <footer class="footer footer-static footer-light navbar-border">
    <p class="clearfix text-muted text-sm-center mb-0 px-2">
      <span class="float-md-left d-xs-block d-md-inline-block"
        >Copyright &copy; 2019-{{ new Date().getFullYear() }}
        <strong>{{ companyName }}</strong
        >, Все права защищены.
      </span>
    </p>
  </footer>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "Footer",
  props: {
    msg: String,
  },
  computed: {
    ...mapGetters(["companyName"]),
  },
};
</script>

<style></style>